import Component from '@glimmer/component';

export default class ProtectAnalyticsUpsellComponent extends Component {
  get ctaId() {
    return this.args.global ? 'analytics_protect_global_upgrade' : 'analytics_protect_upgrade';
  }
}
